import { ReactNode } from 'react';
import bladeStyles from './Blade.module.css';
import styles from './BladeSection.module.css';
import { toTestAttrValue } from '@utils/testAttr';

interface BladeSectionProps {
  title?: ReactNode;
  onClear?: () => void;
  showClear?: boolean;
  children: ReactNode;
  /** Playwright data-section value; defaults to the kebab-cased title when the title is plain text */
  sectionId?: string;
}

const BladeSection = ({ title, onClear, showClear, children, sectionId }: BladeSectionProps) => (
  <div
    className={bladeStyles.section}
    data-testid="blade-section"
    data-section={sectionId ?? (typeof title === 'string' ? toTestAttrValue(title) : undefined)}
  >
    {title && (
      <div className={onClear ? styles.titleRow : undefined}>
        <span className={styles.title}>{title}</span>
        {onClear && showClear && (
          <button className={styles.clearBtn} onClick={onClear} data-testid="blade-section-clear-button">Clear</button>
        )}
      </div>
    )}
    {children}
  </div>
);

export default BladeSection;
